import { render, staticRenderFns } from "./CtaBanner.vue?vue&type=template&id=2cf4b2ed"
import script from "./CtaBanner.vue?vue&type=script&lang=js"
export * from "./CtaBanner.vue?vue&type=script&lang=js"
import style0 from "./CtaBanner.vue?vue&type=style&index=0&id=2cf4b2ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports